import React, {Component} from "react";
import {Link} from "react-router-dom";
import './Signup.css';

class RegistrationOk extends Component {
    constructor(props) {
        super(props);
        this.state = {
            odaAdi: "Eczacı Odası"
        };
    }

    componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search);
        const odaAdi = searchParams.get("oda");
        if (odaAdi) {
            this.setState({ odaAdi });
        }
    }

    render() {
        return (
            <div className="signup-container">
                <div className="signup-content">
                    <h3 className="page-title">
                        Tebrikler! {this.state.odaAdi} Hesabınızı Başarıyla Aktifleştirdiniz!
                    </h3>
                    <div className="center-link">
                        <Link className="center-link" to="/login">Giriş Sayfası.</Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default RegistrationOk;



// WEBPACK FOOTER //
// ./src/page/signup/RegistrationOk.js